import { ApiOptions } from "../types";

export const DefaultDuckDuckGoOptions: ApiOptions = Object.freeze({
  website: null,
  token: "",
});
